/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

// libraries
import React from 'react';
import { withRouter } from 'react-router';
import {
    object, shape, string, bool, array, func,
} from 'prop-types';
import withStyles from '@material-ui/core/styles/withStyles';
import { compose } from 'recompose';
import track from 'react-tracking';

import { trackPage, trackProductData } from '../../../../../../helpers/tracking/common/commonTrackingHelpers';

import { addOgDynamicData, getBreadcrumbArray } from '../../common/commonProductPageHelper';
import GraphqlProductSeoSchema from '../../GraphqlProductSeoSchema/GraphqlProductSeoSchema';
import PDPSkeleton from '../../../../GraphqlSkeletonComponents/PDPSkeleton';
import CYOProductDetails from './CYOProductDetails';
import CYOProductItems from './CYOProductItems';
import GraphqlAgeVerification from '../../CommonProductAgeZipVerify/CommonProductAgeZipVerify';
import { addToCartDataType, deliveryDataType } from '../../common/types';

const styles = (theme) => ({
    root: {
        margin: '0 auto',
        width: '948px',
        padding: '10px 15px',
        [theme.breakpoints.down('sm')]: {
            width: '100%',
            padding: '0',
        },
    },
    breadCrumbBody: {
        display: 'flex',
        margin: '30px auto 10px auto',
        maxWidth: 1380,
    },
    zipCodeInputValid: {
        '&::after': {
            position: 'absolute',
            zIndex: '999',
            // margin: '25px 0px 0px 50px',
            backgroundColor: theme.palette.colorValid,
            color: theme.palette.white,
            textAlign: 'center',
            content: '"✓"',
            margin: '-60px 0px 0px 95px',
            fontSize: '18px',
            padding: '5px',
            fontWeight: 'bold',
            lineHeight: '17px',
            width: '30px',
            height: '30px',
            borderRadius: '50%',
            animation: 'fadeZoomIn 0.3s ease-in',
            display: 'inline-block', // IE 11
        },
    },
    zipCodeInputInvalidIcon: {
        '&::after': {
            position: 'absolute',
            zIndex: '999',
            backgroundColor: theme.palette.cms?.errorZipVerifyPDP,
            color: theme.palette.white,
            textAlign: 'center',
            content: '"X"',
            fontSize: '17px',
            padding: '5px',
            fontWeight: 'bold',
            margin: '-32px 0px 0px 96px',
            lineHeight: '17px',
            width: '30px',
            height: '30px',
            top: 0,
            borderRadius: '50%',
            animation: 'fadeZoomIn 0.3s ease-in',
            display: 'inline-block', // IE 11
        },
    },
    zipInputTextValid: {
        position: 'relative',
        '&::before': {
            position: 'absolute',
            zIndex: '999',
            color: theme.palette.colorValid,
            lineHeight: '25px',
            fontSize: '14px',
            fontWeight: '400',
            content: '"ZIP code confirmed eligible "',
            margin: '10px 0px 0px -100px',
            border: 'none',
            transition: 'opacity 0.3s ease-in',
            opacity: 1,
        },
    },
    zipCodeInputInvalid: {
        position: 'relative',
        '&::before': {
            position: 'absolute',
            zIndex: '999',
            color: theme.palette.cms?.errorZipVerifyPDP,
            lineHeight: '25px',
            fontSize: '14px',
            fontWeight: '400',
            content: '"Not eligible for Wine shipment"',
            bottom: '-34px',
            left: 0,
            paddingLeft: '36px',
            width: 'calc(100% - 8px)',
            height: '25px',
            transition: 'opacity 0.3s ease-in',
            opacity: 1,
        },
    },
    ageInput: {
        width: '100%',
        display: 'flex',  // IE 11
        padding: '8px 0px 8px 0px',
        '& > div': {
            width: '100%', // IE 11
        },
    },
    ageInputInvalid: {
        position: 'relative',
        '&::before': {
            position: 'absolute',
            zIndex: '999',
            color: theme.palette.cms?.errorZipVerifyPDP,
            lineHeight: '25px',
            fontSize: '12px',
            border: 'none',
            fontWeight: '200',
            content: '"You must be 21 or older to purchase Wine !"',
            height: '22px',
            transition: 'opacity 0.3s ease-in',
            opacity: 1,
        },
    },
    dateInvalid: {
        position: 'relative',
        '&::before': {
            position: 'absolute',
            zIndex: '999',
            color: theme.palette.cms?.errorZipVerifyPDP,
            lineHeight: '25px',
            fontSize: '12px',
            border: 'none',
            fontWeight: '200',
            margin: '0px 0px 0px 20px',
            content: '"Please enter a valid date of birth !"',
            height: '22px',
            transition: 'opacity 0.3s ease-in',
            opacity: 1,
        },
    },
    ageInputInvalidIcon: {
        '&::after': {
            position: 'absolute',
            zIndex: '999',
            margin: '-50px 0px 0px 205px',
            backgroundColor: theme.palette.cms?.errorZipVerifyPDP,
            color: theme.palette.white,
            textAlign: 'center',
            content: '"x"',
            fontSize: '20px',
            padding: '3px',
            fontWeight: 'bold',
            lineHeight: '17px',
            left: '7px',
            width: '25px',
            height: '25px',
            borderRadius: '50%',
            animation: 'fadeZoomIn 0.3s ease-in',
            display: 'inline-block', // IE 11
        },
    },
    grid: {
        width: '250px',
        height: '90px',
    },
    ageInputTextValid: {
        position: 'relative',
        '&::before': {
            position: 'absolute',
            zIndex: '999',
            color: theme.palette.colorValid,
            lineHeight: '25px',
            fontSize: '14px',
            fontWeight: '400',
            content: '"Age Confirmed"',
            width: '95px',
            margin: '0px 0px 0px 12px',
            border: 'none',
            transition: 'opacity 0.3s ease-in',
            opacity: 1,
        },
    },
    ageInputValid: {
        '&::after': {
            position: 'absolute',
            zIndex: '999',
            backgroundColor: theme.palette.colorValid,
            color: theme.palette.white,
            textAlign: 'center',
            content: '"✓"',
            margin: '-50px 0px 0px 215px',
            fontSize: '20px',
            padding: '7px',
            fontWeight: 'bold',
            lineHeight: '17px',
            width: '30px',
            height: '30px',
            borderRadius: '50%',
            animation: 'fadeZoomIn 0.3s ease-in',
            display: 'inline-block', // IE 11
        },
    },
});

class GraphqlCYOProductPageBuilder extends React.Component {
    constructor(props) {
        super(props);

        // the SKUs can come back in an unpredictable order but they should either be displayed highest price to lowest
        // or lowest to highest which will be set by product in CMS. The following lines sort the SKUs based on that CMS data
        // .slice is used as to not modify props
        const { content, product } = this.props;
        const productSkus = product ? product.productSkus : null;
        const sku_ranking = content?.entries?.[0]?.sku_section?.sku_ranking;
        if (productSkus) {
            if (sku_ranking === 'low to high') {
                this.sortedData = productSkus
                    .slice(0)
                    .sort(
                        (a, b) => Number(a.prices[0].value) - Number(b.prices[0].value),
                    );
            } else {
                this.sortedData = productSkus
                    .slice(0)
                    .sort(
                        (a, b) => Number(b.prices[0].value) - Number(a.prices[0].value),
                    );
            }
            this.state = { selectedSku: this.sortedData[0] };
        }
    }

    handleSkuChange = (e) => {
        this.setState({
            selectedSku: this.sortedData.find((sku) => sku.id === e.target.value),
        });
    };

    // Track Product
    @track(trackProductData)
    render() {
        const {
            classes,
            seoData,
            product,
            location,
            presentation_family,
            brand,
            content,
            handleMiniCartModalClick,
            cartError,
            hasWine,
            mobileAgeVerificationOpen,
            handleMobileAgeVerification,
            addToCartData,
            deliveryData,
            updateWineStatus,
        } = this.props;

        if (product) {
            const {
                partNumber, shortDescription, name, productSkus, brandId, reviews,
            } = product;
            const { selectedSku } = this.state;

            return (
                <>
                    {addOgDynamicData(product, seoData, brand, location)}
                    <GraphqlProductSeoSchema
                        name={name}
                        shortDescription={shortDescription}
                        partNumber={partNumber}
                        productSkus={productSkus}
                        location={location}
                        brand={brand}
                        reviews={reviews}
                    />
                    <div className={classes.root}>
                        {presentation_family === 'food' && hasWine
                            ? (
                                <GraphqlAgeVerification
                                    classes={classes}
                                    updateWineStatus={updateWineStatus}
                                    selectedSku={selectedSku}
                                    deliveryData={deliveryData}
                                    productSkus={selectedSku}
                                    brand={brand}
                                    mobileAgeVerificationOpen={mobileAgeVerificationOpen}
                                    handleMobileAgeVerification={handleMobileAgeVerification}
                                    addToCartData={addToCartData}
                                    modal
                                />
                            )
                            : null}
                        <div className={classes.breadCrumbBody}>{getBreadcrumbArray(product, location)}</div>
                        <div>
                            <CYOProductDetails
                                content={content}
                                data={product}
                                selectedSku={selectedSku}
                                location={location}
                                skuData={this.sortedData}
                                handleSkuChange={this.handleSkuChange}
                                presentation_family={presentation_family}
                                brand={brand}
                            />
                            <div>
                                <CYOProductItems
                                    handleMiniCartModalClick={handleMiniCartModalClick}
                                    cyoData={selectedSku.cyo}
                                    selectedItemId={selectedSku.id}
                                    brandId={brandId}
                                    product={product}
                                    cartError={cartError}
                                    hasWine={hasWine}
                                    handleMobileAgeVerification={handleMobileAgeVerification}
                                />
                            </div>
                        </div>
                    </div>
                </>
            );
        }
        return <PDPSkeleton />;
    }
}
GraphqlCYOProductPageBuilder.propTypes = {
    classes: object.isRequired,
    content: object.isRequired,
    product: object.isRequired,
    location: object.isRequired,
    handleMiniCartModalClick: func.isRequired,
    seoData: shape({
        seo_searchable: bool,
        page_title: string,
        keywords: string,
        meta_description: string,
        og: array,
    }).isRequired,
    presentation_family: string.isRequired,
    brand: object.isRequired,
    cartError: string.isRequired,
    hasWine: bool,
    updateWineStatus: func,
    mobileAgeVerificationOpen: bool,
    handleMobileAgeVerification: func,
    addToCartData: addToCartDataType,
    deliveryData: deliveryDataType,
};

GraphqlCYOProductPageBuilder.defaultProps = {
    hasWine: false,
    updateWineStatus: () => {},
    mobileAgeVerificationOpen: false,
    handleMobileAgeVerification: () => { },
    addToCartData: {},
    deliveryData: {},
};

const enhance = compose(
    trackPage(),
    withRouter,
    withStyles(styles),
);

export default enhance(GraphqlCYOProductPageBuilder);
